/**
 * Angular 2 decorators and services
 */
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router }   from '@angular/router';
import { SnotifyService } from 'ng-snotify';

import { AuthService } from './auth';

/**
 * App Component
 * Top Level Component
 */
@Component({
  selector: 'app',
  encapsulation: ViewEncapsulation.None,
  styleUrls: [
    './app.component.scss'
  ],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  public user;
  public showUserPicture: boolean = false;

  constructor(
    public authService: AuthService,
    public snotifyService: SnotifyService,
    private router: Router
  ) {}

  public ngOnInit() {
    this.authService.silentLogin().subscribe();

    this.authService.getUser()
    .subscribe((user) => {
      this.user = user;
      if (this.user) {
        setTimeout(() => {
          this.showUserPicture = true;
        }, 800);
      }
      else {
        this.showUserPicture = false;
      }
    });
  }

  public notImplemented () {
      this.snotifyService.info('Non implémenté');
  }

  public logout () {
    this.authService.logout();
    this.router.navigateByUrl('/login');
  }

}

/**
 * Please review the https://github.com/AngularClass/angular2-examples/ repo for
 * more angular app examples that you may copy/paste
 * (The examples may not be updated as quickly. Please open an issue on github for us to update it)
 * For help or questions please contact us at @AngularClass on twitter
 * or our chat on Slack at https://AngularClass.com/slack-join
 */



// WEBPACK FOOTER //
// ./src/app/app.component.ts